export type ServiceOrder = {
  createdAt: string;
  delivery: ServiceOrderDelivery;
  status: DisplayName;
  label: string;
  readyProducts: number;
  totalProducts: number;
  products: Array<ServiceOrderProduct>;
};

export type ServiceOrderProduct = {
  brandName: string;
  inProgress: boolean;
  label: string;
  locations: Array<string>;
  images: Array<{ name: string; path: string }>;
  productType: DisplayName;
  status: DisplayName;
};

export type ServiceOrderDelivery = {
  date: string;
  leadTime: number;
  publicDisplayName: string;
};

export type DisplayName = {
  publicDisplayName: string;
};

export type ItemTimeLineData = {
  name: string;
  publicDisplayName: string;
  key: string;
  current: boolean;
  processedAt: string;
  location?: ItemTimelineLocationData;
  updatedBy?: {
    id: number;
    name: string;
  };
};

export type ItemTimelineLocationData = {
  name: string;
  publicDisplayName: string;
  key: string;
  type: string;
  status: Array<ItemTimelineLocationStatusData>;
};

export type ItemTimelineLocationStatusData = {
  name: string;
  publicDisplayName: string;
  key: string;
  processedAt: string;
  updatedBy?: {
    id: number;
    name: string;
  };
};
